import { WebApiService } from './plugins/webApiService';
import ProjectBaseService from './projects/base/service/ProjectBaseService';
import ProjectGroupService from './projects/groups/service/ProjectGroupService';
import ProjectNamespaceService from './projects/groups/service/ProjectNamespaceService';
import ProjectQueueTaskService from './projects/groups/service/ProjectQueueTaskService';
import SettingColorService from './projects/groups/service/SettingColorService';
import SettingIconService from './projects/groups/service/SettingIconService';
import SettingQueueTaskTemplateService from './projects/groups/service/SettingQueueTaskTemplateService';
import NamespaceAdminRoleService from './projects/performers/i-service/NamespaceAdminRoleService';
import EmployeeService from './projects/performers/service/EmployeeService';
import PerformersListService from './projects/performers/service/PerformersListService';
import ProjectAdminRoleService from './projects/performers/service/ProjectAdminRoleService';
import QueueTaskAdminRoleService from './projects/performers/service/QueueTaskAdminRoleService';
import EstimateInviteService from './projects/task/service/EstimateInviteService';
import ProjectTaskGetService from './projects/task/service/ProjectTaskGetService';
import ProjectTaskSaveService from './projects/task/service/ProjectTaskSaveService';
import TagGetService from './projects/task/service/TagGetService';
import TagSaveService from './projects/task/service/TagSaveService';
import TaskActionHistoryService from './projects/task/service/TaskActionHistoryService';
import TaskDifficultyListService from './projects/task/service/TaskDifficultyListService';
import TaskDifficultySaveService from './projects/task/service/TaskDifficultySaveService';
import TaskOrderGetService from './projects/task/service/TaskOrderGetService';
import TaskOrderSaveService from './projects/task/service/TaskOrderSaveService';
import TaskPriorityGetService from './projects/task/service/TaskPriorityGetService';
import TaskPrioritySaveService from './projects/task/service/TaskPrioritySaveService';
import TaskStatusListService from './projects/task/service/TaskStatusListService';
import TaskStatusSaveService from './projects/task/service/TaskStatusSaveService';
import TaskTypeListService from './projects/task/service/TaskTypeListService';
import TaskTypeSaveService from './projects/task/service/TaskTypeSaveService';
import TaskTimersService from './projects/task-timer/service/TaskTimersService';
import TaskCommentService from './projects/task-comments/service/TaskCommentService';
import UsersService from './users/base/service/UsersService'

export default class apiDataSourceMain {
	/**
	 * * Сервис для общих методов управления проектами
	 */
	ProjectBaseService: ProjectBaseService;
	/**
	 * * Сервис для работы с группами
	 */
	ProjectGroupService: ProjectGroupService;
	/**
	 * * Сервис управления неймспейсами
	 */
	ProjectNamespaceService: ProjectNamespaceService;
	/**
	 * * Сервис управления очередь задачами
	 */
	ProjectQueueTaskService: ProjectQueueTaskService;
	/**
	 * * Сервис для управления настройками цветов
	 */
	SettingColorService: SettingColorService;
	/**
	 * * Сервис для управления иконками
	 */
	SettingIconService: SettingIconService;
	/**
	 * * Сервис для настройки шаблонов очередей задач
	 */
	SettingQueueTaskTemplateService: SettingQueueTaskTemplateService;
	/**
	 * * Сервис управления ролью NamespaceAdmin
	 */
	NamespaceAdminRoleService: NamespaceAdminRoleService;
	/**
	 * * Сервис команды
	 */
	EmployeeService: EmployeeService;
	/**
	 * * Сервис для получения списков сотрудников
	 */
	PerformersListService: PerformersListService;
	/**
	 * * Сервис управления ролями ProjectAdmin
	 */
	ProjectAdminRoleService: ProjectAdminRoleService;
	/**
	 * * Сервис для назначения доступа пользователям к очередям
	 */
	QueueTaskAdminRoleService: QueueTaskAdminRoleService;
	/**
	 * * Сервис приглашений на оценку
	 */
	EstimateInviteService: EstimateInviteService;
	/**
	 * * Сервис для получения информации о задачах
	 */
	ProjectTaskGetService: ProjectTaskGetService;
	/**
	 * * Сервис для редактирования задачи
	 */
	ProjectTaskSaveService: ProjectTaskSaveService;
	/**
	 * * Сервис для получения тегов
	 */
	TagGetService: TagGetService;
	/**
	 * * Сервис для сохранения тегов
	 */
	TagSaveService: TagSaveService;
	/**
	 * * Сервис для получения информации о изменениях задачи
	 */
	TaskActionHistoryService: TaskActionHistoryService;
	/**
	 * * Сервис для получения уровней сложности задач
	 */
	TaskDifficultyListService: TaskDifficultyListService;
	/**
	 * * Сервис для сохранения информации об уровнях сложности
	 */
	TaskDifficultySaveService: TaskDifficultySaveService;
	/**
	 * * Сервис для получения данных очередности задач
	 */
	TaskOrderGetService: TaskOrderGetService;
	/**
	 * * Сервис сохранения сортировки задач
	 */
	TaskOrderSaveService: TaskOrderSaveService;
	/**
	 * * Сервис получения приоритетов
	 */
	TaskPriorityGetService: TaskPriorityGetService;
	/**
	 * * Сервис работы с приоритетами
	 */
	TaskPrioritySaveService: TaskPrioritySaveService;
	/**
	 * * Сервис для получения списков задач
	 */
	TaskStatusListService: TaskStatusListService;
	/**
	 * * Сервис сохранения и изменения статусов задач
	 */
	TaskStatusSaveService: TaskStatusSaveService;
	/**
	 * * Сервис для получения списа типов задач
	 */
	TaskTypeListService: TaskTypeListService;
	/**
	 * * Сервис для сохранения типов задач
	 */
	TaskTypeSaveService: TaskTypeSaveService;
	/**
	 * * Сервис для работы с таймерами задач
	 */
	TaskTimersService: TaskTimersService;
	/**
	 * * Сервис для работы с комментариями
	 */
	TaskCommentService: TaskCommentService;
	/**
	 * * Сервис для управления пользователями
	 */
	UsersService: UsersService;
	constructor(cookieName?: string) {
		this.ProjectBaseService = new ProjectBaseService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.ProjectGroupService = new ProjectGroupService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.ProjectNamespaceService = new ProjectNamespaceService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.ProjectQueueTaskService = new ProjectQueueTaskService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.SettingColorService = new SettingColorService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.SettingIconService = new SettingIconService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.SettingQueueTaskTemplateService = new SettingQueueTaskTemplateService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.NamespaceAdminRoleService = new NamespaceAdminRoleService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.EmployeeService = new EmployeeService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.PerformersListService = new PerformersListService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.ProjectAdminRoleService = new ProjectAdminRoleService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.QueueTaskAdminRoleService = new QueueTaskAdminRoleService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.EstimateInviteService = new EstimateInviteService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.ProjectTaskGetService = new ProjectTaskGetService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.ProjectTaskSaveService = new ProjectTaskSaveService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TagGetService = new TagGetService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TagSaveService = new TagSaveService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskActionHistoryService = new TaskActionHistoryService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskDifficultyListService = new TaskDifficultyListService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskDifficultySaveService = new TaskDifficultySaveService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskOrderGetService = new TaskOrderGetService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskOrderSaveService = new TaskOrderSaveService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskPriorityGetService = new TaskPriorityGetService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskPrioritySaveService = new TaskPrioritySaveService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskStatusListService = new TaskStatusListService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskStatusSaveService = new TaskStatusSaveService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskTypeListService = new TaskTypeListService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskTypeSaveService = new TaskTypeSaveService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskTimersService = new TaskTimersService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.TaskCommentService = new TaskCommentService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.UsersService = new UsersService(undefined, cookieName, "appWebSettings.json", "apiUrl");
	}

}
